import { useMutation } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { useNotification } from '../../notification/notificationsContext';
import useAnalytics from '../../web-analytics/webAnalyticsContext';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const useUnpauseMutation = (props: { onSuccess?: () => void }) => {
  const { onSuccess } = props;
  const queryCacheManager = useQueryCacheManager();
  const { billingApi } = useApi();
  const { notifyError } = useNotification();
  const analytics = useAnalytics();

  return useMutation(async () => billingApi.unpauseBillingPlan(), {
    onSuccess: async () => {
      onSuccess && onSuccess();
      await queryCacheManager.invalidateBillingCustomer();
      await queryCacheManager.invalidateInvoices();

      analyticsTrack(analytics, AnalyticsEvent.BILLING_PLAN_UNPAUSED);
    },
    onError: async () => {
      await queryCacheManager.invalidateBillingCustomer();
      await queryCacheManager.invalidateInvoices();

      notifyError({
        notificationMsg: 'Failed to resume plan. Please try again or contact support.',
      });
    },
  });
};
